import Events from "../Events";
import $ from "jquery";
import Backbone from "backbone";
import RowsStorage from "../storage/RowsStorage";
import "../../plugins/jquery.cookie";


const LIST_USER = RowsStorage.get("LIST_USER");
const globalEvents = new Events();

export default class User extends Events {

    // кто-то хочет слушать события любой группы
    // " Room.on = globalEvents.on.bind(Room) " is bad
    // Room._events
    //
    //  some.listenTo(Room, name, callback)
    static on(name, callback) {
        globalEvents.on(name, callback);
    }

    //  some.clearEvents();
    static off(name, callback) {
        globalEvents.off(name, callback);
    }

    constructor() {
        super();

        const userRowFromCookie = JSON.parse($.cookie("user"));
        this.model = new Backbone.Model(userRowFromCookie);
        this.id = this.model.id;
    }

    async load() {
        await this.loadSettings();
        this.trigger("ready");
    }

    async loadSettings() {
        this._settings = new Backbone.Model();

        // для формы заказа, менеджер по умолчанию
        const model = await LIST_USER.get(this.id);

        if ( !model ) {
            this.trigger("roles:ready", []);
            this.trigger("settings:ready");
            return;
        }

        let roles = model.get("ROLES") || [];
        roles = roles.map((role) => {
            let splitted = role.split(":");
            let id = +splitted[0];
            let name = splitted.slice(1).join(":");

            return {
                id,
                name
            };
        });
        this.roles = roles;
        this.trigger("roles:ready", roles);

        this.model.set(model.attributes, { silend: true });
        this._settings.set(model.get("SETTINGS"), { silent: true });

        this.trigger("settings:ready");
    }

    // @see System.js
    subscribeOnSocket(socketClient) {
        this.listenTo(socketClient, "userAction", (ev) => {
            let event = ev.ev;
            let action = event.action;
            let userId = event.userId;
            let lastSeen = event.data.lastSeen;
            let userModel = LIST_USER.collection.get(userId);

            if ( userModel ) {
                userModel.set({
                    LAST_SEEN_DATE: lastSeen,
                    IS_ONLINE: action == "connected"
                }, { update: false });
            }

            globalEvents.trigger("action", {
                action,
                userId,
                lastSeen
            });
        });
    }

    isAdmin() {
        let isAdmin = false;
        for (let i = 0, n = this.roles && this.roles.length; i < n; i++) {
            if ( this.roles[i].id == 1 ) {
                isAdmin = true;
            }
        }

        return isAdmin;
    }

    hasRole(roleId) {
        return this.roles.some((role) => {
            return role.id == roleId;
        });
    }


    // clientId for all requests
    getApiData() {
        return {};
    }

}
